import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-change-role-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule, NgMultiSelectDropDownModule],
  templateUrl: './change-role-dialog.component.html',
  styleUrl: './change-role-dialog.component.scss'
})
export class ChangeRoleDialogComponent {

  selectedRole: string = '';
  dropdownSettings: IDropdownSettings = {};
  categoryDropdownList: any = [];
  selectedCategoryItems: any = [];

  isCatvalid:boolean = false;
  formSubmitted: boolean = false;

  rolesList: any = [
    {
      role_id: 1, role_name: 'admin'
    },
    {
      role_id: 3, role_name: 'creator'
    },
    {
      role_id: 2, role_name: 'curator'
    },
    {
      role_id: 4, role_name: 'user'
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChangeRoleDialogComponent>,
  ){

  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    if (this.data) {
      this.categoryDropdownList = this.data;
    }

  }

  onCategoryItemSelect(e:any) {
  
  }

  roleItemChange(e:any) {
    this.isCatvalid = false;
  }

  close() {
    this.formSubmitted = false;
    this.dialogRef.close();
  }

  submit() {
    this.formSubmitted = true;
    if( !this.selectedRole ) {
      return;
    }
    if(this.selectedRole === 'curator' && !this.selectedCategoryItems.length) {
      this.isCatvalid = true;
      return;
    }
    const postData = {
      role: this.selectedRole,
      categories: this.selectedCategoryItems.length ? this.selectedCategoryItems : null
    }
   
    
    this.isCatvalid = false;
    this.dialogRef.close(postData);
  }

}
